import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {surveyWaveCreateSuccess} from '../../../actions/action_survey_wave';
import * as api from '../../../services/api';
import messages from '../../../../res/translations/messages';
import WaveForm from './WaveForm';

const WaveCreate = () => {
    const survey = useSelector((state) => state.survey.item);
    const dispatch = useDispatch();
    const history = useHistory();
    const [submitting, setSubmitting] = React.useState(false);
    const initialValues = {name: '', startDate: '', endDate: ''};
    const handleSubmit = React.useCallback(
        (values) => {
            api.createSurveyWave(survey.id, values)
                .finally(() => {
                    setSubmitting(false);
                })
                .then((response) => {
                    dispatch(surveyWaveCreateSuccess(response.data));
                    const lastWave = response.data.waves[response.data.waves.length - 1];
                    history.push(`/surveys/${survey.id}/trackers/wave/${lastWave.id}`);
                });
        },
        [dispatch, history, survey.id]);
    return (
        <div className="survey-editor-item p-3">
            <h5><FormattedMessage {...messages.waves.create.title} /></h5>
            <WaveForm initialValues={initialValues} onSubmit={handleSubmit} surveyId={survey.id} submitting={submitting} />
        </div>
    );
};

export default WaveCreate;
